/**
 * A股页面
 */
import React from "react"
import "./index.less"
import { StockHeader } from "../../shared/stock_header"
import { quotedata } from "../../shared/quotedata"
import { StockInfoTabs } from "../../shared/stock_info_tabs"
import { ChartTab } from "../../shared/chart_tab"
import { store } from "./store"
import { OpenInApp } from "../../shared/open_in_app"
import { GoTop } from "../../shared/go_top"
import { CommonFooter } from "../../shared/common_footer"
import { StockFixedFooter } from "../../shared/stock_fixed_footer"
import { AdvertiseTop } from "../../shared/advertise_top"
import { ABasicInfo } from "./basic_info"
import { getPageType, getStockSubType, PageType, StockSubType, getStockErrorTradeStatus } from "../../shared/pagetype"
import { Observer } from "mobx-react-lite"
import { AfterPrice } from "./after_price"
import { getMarketSource } from "../../../modules/quote/web"
import { RollPrice } from "./roll_price"
import { SpecialTips } from "./special_tips"

export function Page_A(props: { quotedata: quotedata }) {
  let pagetype = getPageType()
  let stocksubtype = getStockSubType()
  let trade_status = getStockErrorTradeStatus() 
  let _market = getMarketSource(props.quotedata.quotecode)
  let infoTabs = ["股吧", "盘口", "资讯", "公告", "研报", "财务", "必读"]
  if (stocksubtype == StockSubType.北证A股) {
    infoTabs = ["股吧", "资讯", "公告", "研报", "财务", "必读"]
  }

  return (
    <>
      <AdvertiseTop />
      <div className="stock-detail">
        <WrapStockHeader quotedata={props.quotedata} pagetype={pagetype} />
        <ABasicInfo stocksubtype={stocksubtype} quotedata={props.quotedata} pagetype={pagetype} trade_status={trade_status}/>
        <WrapRollPrice pagetype={pagetype} quotedata={props.quotedata} stocksubtype={stocksubtype} />
        <AfterPrice stocksubtype={stocksubtype} />
        <SpecialTips quotecode={props.quotedata.code}/>
        <WrapCharts quotedata={props.quotedata} pagetype={pagetype} stocksubtype={stocksubtype} />
        <StockInfoTabs showTabs={infoTabs} quotedata={props.quotedata} pagetype={pagetype} _market={_market} stocksubtype={stocksubtype} />
      </div>
      <OpenInApp quotedata={props.quotedata} type={"page"} />
      <GoTop />
      <CommonFooter quotedata={props.quotedata} hide_fix_bottom={false} />
      <StockFixedFooter quotedata={props.quotedata} pagetype={pagetype} />
    </>
  )
}

function WrapStockHeader(props: { quotedata: quotedata; pagetype: PageType }) {
  return <Observer>{() => <StockHeader quotedata={props.quotedata} detail_data={store.StockDetail} pagetype={props.pagetype} />}</Observer>
}

function WrapCharts(props: { quotedata: quotedata; pagetype: PageType; stocksubtype: StockSubType }) {
  return <Observer>{() => <>{store.StockDetail && <ChartTab quotedata={props.quotedata} pagetype={props.pagetype} stocksubtype={props.stocksubtype} />}</>}</Observer>
}

function WrapRollPrice(props: { pagetype: PageType; quotedata: quotedata; stocksubtype: StockSubType }) {
  
  return (
    <Observer>
      {() => (
        <>
          <RollPrice stocksubtype={props.stocksubtype} quotedata={props.quotedata} pagetype={props.pagetype} detail_data={store.StockDetail}/>
        </>
      )}
    </Observer>
  )
}


// function WrapPriceComparison(props: { pagetype: PageType }) {
//   return <Observer>{() => <>{store.StockDetail && (store.StockDetail.f256 && store.StockDetail.f256 != "-" ? <AHPrice pagetype={props.pagetype} /> : <ABPrice pagetype={props.pagetype} />)}</>}</Observer>
// }

// function WrapKZZPrice(props: { pagetype: PageType; quotedata: quotedata; stocksubtype: StockSubType }) {
//   return (
//     <Observer>
//       {() => (
//         <>
//           {store.StockDetail && ((store.StockDetail.f256 && store.StockDetail.f256 != "-") || (store.StockDetail.f269 && store.StockDetail.f269 != "-")) ? (
//             <></>
//           ) : (
//           <KZZPrice quotedata={props.quotedata} pagetype={props.pagetype} detail_data={store.StockDetail} stocksubtype={props.stocksubtype} />
//           )} 
//         </>
//       )}
//     </Observer>
//   )
// }

